import React, {useState, useCallback, useEffect} from "react";
import { Grid } from 'semantic-ui-react';
import { Provider } from "react-redux";
import store from "./store/index";
import Recon from "./components/Recon";
import ReconGlobalProvider from "./components/providers/ReconGlobalProvider";
import TopHeader from "./components/commonComponents/header/topHeader";
import Images from "../config/images"
import './reconScss/index.scss';




const ReconApp = (props) => {
  const kxUser = JSON.parse(sessionStorage.getItem("kxUser"))
  return ( 
    <Provider store={store}>
      <ReconGlobalProvider kxUser={kxUser}>
        <Grid>
          <Grid.Row columns={2} className="recon-top-header">
            <TopHeader logo={Images.knlogonew}></TopHeader>
          </Grid.Row>
          <Grid.Row className="recon-container">
            <Recon />
          </Grid.Row>
        </Grid>
      </ReconGlobalProvider>
    </Provider>
  );
}
 
export default ReconApp;